module.exports = __webpack_public_path__ + "static/media/hoogle_icon.bb28d0ba.png";